import { Theme } from '@material-ui/core';
import { CSSProperties } from 'styled-components';
import { grey } from 'globals/colors';

export const getWrapperBoxStyle = ({ spacing }: Theme): CSSProperties => ({
  // boxShadow: `inset 0px 0px 8px 1px ${fade(black, 0.1)}`,
  padding: spacing(1, 2),
  backgroundColor: grey.V5,
});

export default {
  getWrapperBoxStyle,
};
